import { createSlice } from '@reduxjs/toolkit';
import DataExportsAPI from '~/api/data-exports-api';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import { defaultState } from './data/DataExportsState';

export const getDataExports = createCaughtAsyncThunk(
  'getDataExports',
  async () => {
    return DataExportsAPI.getDataExports();
  }
);

export const getExportDownloadUrl = createCaughtAsyncThunk<
  { url: string },
  string
>('getDataExportDownloadUrl', async (id) => {
  return DataExportsAPI.getExportDownloadUrl(id);
});

const slice = createSlice({
  name: 'data-exports',
  initialState: defaultState,
  reducers: {
    resetDownloadUrl: (state) => {
      delete state.downloadUrl;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDataExports.pending, (state) => {
        state.isLoading = true;
        delete state.error;
      })
      .addCase(getDataExports.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getDataExports.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getExportDownloadUrl.fulfilled, (state, action) => {
        state.downloadUrl = action.payload.url;
      })
      .addCase(getExportDownloadUrl.rejected, (state, action) => {
        delete state.downloadUrl;
        state.downloadUrlError = action.payload;
      });
  },
});

export const { resetDownloadUrl } = slice.actions;
export default slice.reducer;
